// extracted by mini-css-extract-plugin
export default {"breadCrumbs":"SiteBreadCrumbs_breadCrumbs__+G4Vq"};